import { makeStyles } from 'tss-react/mui';

import { BASE_STAT_WIDTH } from 'modules/common/const';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
  },

  content: {
    display: 'grid',
    gap: theme.spacing(3),
    gridTemplateColumns: `1fr calc(${BASE_STAT_WIDTH * 2}px + ${theme.spacing(3)})`,
    gridTemplateRows: 'max-content',

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));
